import React, {Fragment} from 'react';
import {Card, InlineNumberFormat} from 'components';
import {useNamedSelector, useSelector} from 'helpers';
import {units} from 'store';

export function TrackStats({id, unitId}) {
  const unit = useSelector(units.getById)(unitId);
  const {value, total} = useNamedSelector('goals.progressSummary', {id});
  return Boolean(total || value) && (
    <Card.Note>
      { value > 0 &&
        <InlineNumberFormat value={value} unit={!total && unit?.name} />
      }
      { total > 0 &&
        <Fragment>
          { Boolean(value) && ' / ' }
          <InlineNumberFormat value={total} unit={unit?.name} />
        </Fragment>
      }
    </Card.Note>
  );
}
